import { createSelector } from 'reselect';

const getItems = state => state.items;
const getList = state => {
  if (state.followOrder) {
    return state.list;
  }

  return state.list.sort((a, b) => {
    const first = state.items[a.type][a.id];
    const second = state.items[b.type][b.id];
    if (first.public === second.public) {
      return first.name < second.name ? -1 : first.name > second.name ? 1 : 0;
    }
    if (first.public && !second.public) {
      return -1;
    }
    if (!first.public && second.public) {
      return 1;
    }
    return 0;
  });
};
const getFilter = state => state.filter;

const makeGetVisibleStoreItems = () => {
  return createSelector(getItems, getList, getFilter, (items, list, filter) => {
    let filtered;
    filtered = list.filter(storeItem => {
      const item = items[storeItem.type][storeItem.id];
      return (
        !filter.categoryId ||
        (item.categories && item.categories[filter.categoryId])
      );
    });
    if (filter.tags) {
      filtered = filtered.filter(storeItem => {
        const item = items[storeItem.type][storeItem.id];
        return Object.keys(filter.tags).every(
          tag => !filter.tags[tag] || item.tagsMap[tag]
        );
      });
    }
    // if (filter.searchText) {
    //   const regexp = new RegExp(filter.searchText, 'i');
    //   filtered = filtered.filter(storeItem => {
    //     const item = items[storeItem.type][storeItem.id];

    //     return (item.name + item.description).search(regexp) > -1;
    //   });
    // }
    return filtered.map(({ type, id }) => items[type][id]);
  });
};

export const getVisibleStoreItems = makeGetVisibleStoreItems();

const makeGetStoreItems = () => {
  return createSelector(getItems, getList, (items, list) =>
    list.map(({ type, id }) => items[type][id])
  );
};

export const getStoreItems = makeGetStoreItems();

const makeGetFilteredStoreItems = () => {
  return createSelector(
    list => list,
    (list, filter) => filter,
    (list, filter) => {
      let filtered;
      filtered = list.filter(item => {
        return (
          !filter.categoryId ||
          (item.categories && item.categories[filter.categoryId])
        );
      });
      if (filter.tags) {
        filtered = filtered.filter(item => {
          return Object.keys(filter.tags).every(
            tag => !filter.tags[tag] || item.tagsMap[tag]
          );
        });
      }
      // if (filter.searchText) {
      //   const regexp = new RegExp(filter.searchText, 'i');
      //   filtered = filtered.filter(item => {
      //     return (item.name + item.description).search(regexp) > -1;
      //   });
      // }
      return filtered;
    }
  );
};

export const getFilteredStoreItems = makeGetFilteredStoreItems();

const makeGetSearchedStoreItems = () => {
  return createSelector(
    list => list,
    (list, filter) => filter,
    (list, filter) => {
      let filtered;
      filtered = list.filter(item => {
        return (
          !filter.categoryId ||
          (item.categories && item.categories[filter.categoryId])
        );
      });
      if (filter.tags) {
        filtered = filtered.filter(item => {
          return Object.keys(filter.tags).every(
            tag => !filter.tags[tag] || item.tagsMap[tag]
          );
        });
      }
      if (filter.searchText) {
        const regexp = new RegExp(filter.searchText, 'i');
        filtered = filtered.filter(item => {
          return (item.name + item.description).search(regexp) > -1;
        });
      }
      return filtered;
    }
  );
};

export const getSearchedStoreItems = makeGetSearchedStoreItems();

const makeGetSelectedItem = () => {
  return createSelector(
    state => state.selected,
    getItems,
    ({ type, id }, items) => {
      return (id && items[type][id]) || null;
    }
  );
};

export const getSelectedItem = makeGetSelectedItem();

const makeGetCart = () => {
  return createSelector(
    getItems,
    state => state.cart,
    (items, cart) =>
      cart
        .map(({ type, id }) => {
          if (items[type] && items[type][id]) {
            return items[type][id];
          }
          return null;
        })
        .filter(item => item !== null)
  );
};

export const getCart = makeGetCart();

export const isGift = createSelector(
  state => state.cart,
  cart => cart.some(({ gift }) => gift)
);

const getSection = (sections, modules, sectionId, marked) => {
  const section = sections[sectionId];
  return {
    ...section,
    marked,
    modules: section.modules
      .filter(moduleId => modules[moduleId])
      .map(moduleId => modules[moduleId])
  };
};

const makeGetLayout = () => {
  return createSelector(
    state => {
      const { mode } = state;
      const layout = mode === 'editor' ? state.layoutDraft : state.layout;
      const { entities, ...other } = layout;
      return { ...other };
    },
    state => {
      const { mode } = state;
      const layout = mode === 'editor' ? state.layoutDraft : state.layout;
      return layout.entities.sections;
    },
    state => {
      const { mode } = state;
      const layout = mode === 'editor' ? state.layoutDraft : state.layout;
      return layout.entities.modules;
    },
    state => {
      const { mode } = state;
      const layout = mode === 'editor' ? state.layoutDraft : state.layout;
      return layout.overSection;
    },
    (layout, sections, modules, overSection) => {
      return {
        ...layout,
        sections: layout.sections.map(sectionId =>
          getSection(
            sections,
            modules,
            sectionId,
            overSection && overSection.id === sectionId
              ? overSection.position
              : null
          )
        )
      };
    }
  );
};

export const getLayout = makeGetLayout();

const makeGetSelectedModule = () => {
  return createSelector(
    state => state.mode,
    state => (state.layoutDraft && state.layoutDraft.entities) || {},
    state => state.layoutDraft && state.layoutDraft.selectedModuleId,
    (mode, entities, selectedModuleId) => {
      return mode === 'list' || !entities || !entities.sections
        ? undefined
        : entities.modules[selectedModuleId];
    }
  );
};

export const getSelectedModule = makeGetSelectedModule();

const makeGetSelectedSection = () => {
  return createSelector(
    state => state.mode,
    state => state.layoutDraft && state.layoutDraft.entities,
    state => state.layoutDraft && state.layoutDraft.selectedSectionId,
    (mode, entities, selectedSectionId) => {
      return mode === 'list' || !entities || !entities.sections
        ? undefined
        : entities.sections[selectedSectionId];
    }
  );
};

export const getSelectedSection = makeGetSelectedSection();



// WEBPACK FOOTER //
// ./src/js/selectors/store.js